/**
 * Dev-context session helpers
 *
 * Tiny module so session.store can clear the dev business context
 * without pulling the entire DevPortalPage into the main bundle.
 */

const DEV_CONTEXT_KEY = 'dev:selectedBusiness';

export interface DevContext {
  id: string;
  name: string;
}

export function saveDevContext(biz: { id: string; name: string }) {
  try {
    sessionStorage.setItem(
      DEV_CONTEXT_KEY,
      JSON.stringify({ id: biz.id, name: biz.name })
    );
  } catch {
    // storage full or unavailable — ignore
  }
}

export function loadDevContext(): DevContext | null {
  try {
    const raw = sessionStorage.getItem(DEV_CONTEXT_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (parsed?.id && parsed?.name) return parsed;
  } catch {
    // corrupted — clean up
    sessionStorage.removeItem(DEV_CONTEXT_KEY);
  }
  return null;
}

export function clearDevContext() {
  sessionStorage.removeItem(DEV_CONTEXT_KEY);
}
